import { computed, onMounted, ref } from 'vue'

const viewportWidth = ref(typeof window === 'undefined' ? 1024 : window.innerWidth)
let listenerAttached = false

function updateViewportWidth() {
  viewportWidth.value = window.innerWidth
}

function ensureViewportListener() {
  if (listenerAttached || typeof window === 'undefined') return
  listenerAttached = true
  viewportWidth.value = window.innerWidth
  window.addEventListener('resize', updateViewportWidth, { passive: true })
}

export function useBreakpoint() {
  onMounted(ensureViewportListener)

  return {
    viewportWidth,
    isPhone: computed(() => viewportWidth.value < 640),
    isTablet: computed(() => viewportWidth.value >= 640 && viewportWidth.value < 1024),
    isTabletUp: computed(() => viewportWidth.value >= 640),
    isDesktop: computed(() => viewportWidth.value >= 1024),
    isWide: computed(() => viewportWidth.value >= 1440)
  }
}
